import { render, staticRenderFns } from "./cloud-film.vue?vue&type=template&id=77d560b7&scoped=true"
import script from "./cloud-film.vue?vue&type=script&lang=js"
export * from "./cloud-film.vue?vue&type=script&lang=js"
import style0 from "./cloud-film.vue?vue&type=style&index=0&id=77d560b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d560b7",
  null
  
)

export default component.exports